export let discountUnitPrice = function (product, discount) {
  let price = product.unit_price || product.unit_price_at_purchase;

  if (price === null) {
    return;
  }
  if (product.unit_price_at_purchase) {
    return product.unit_price_at_purchase;
  } else if (product.discounted_unit_price) {
    return product.discounted_unit_price;
  }
  if (discount && discount.is_mix_match && discount.target_container == "units") {
    price -= discount.discount_per_unit;
  } else if (discount) {
    if (discount.target_container == "units" || product.container_type == "keg") {
      price -= discount.amount;
    }
  }
  return price;
};

export let discountCasePrice = function (product, discount) {
  let price = product.case_price || product.case_price_at_purchase;
  if (price === null) {
    return;
  }
  if (product.case_price_at_purchase) {
    return product.case_price_at_purchase;
  } else if (product.discounted_case_price) {
    return product.discounted_case_price;
  } else if (discount && discount.is_mix_match) {
    if (discount.discount_per_unit) {
      price -= discount.discount_per_unit * (product.container_case_size || 1);
    } else {
      price -= discount.amount;
    }
  } else if (discount) {
    if (discount.target_container != "units") {
      price -= discount.amount;
    } else if (discount.target_container == "units") {
      price -= discount.amount * (product.container_case_size || 1);
    }
  }
  return price;
};

export default { discountUnitPrice, discountCasePrice };
